module.exports = __webpack_public_path__ + "static/periapt_of_wound_closure-39179ee6db7e8ecbb9545760523ffc21.jpeg";